<p-card header="{{wiadomosc.tytul}}" subheader="{{wiadomosc.data}}, {{wiadomosc.autor}}" [style]="{width: '100%'}" styleClass="ui-card-shadow">
  <div>
    {{wiadomosc.tresc}}
  </div>
  <p-footer *ngIf="wiadomosc.link">
    <a href="{{wiadomosc.link}}">Link</a>
  </p-footer>
</p-card>
<br>
